import { Text, useStyleConfigV2 } from '@tectonic/elemason-components';
import { ElemasonComponentType } from '@tectonic/types';
import { Toast as UiToast, useThemeContext } from '@tectonic/uikit';
import clsx from 'clsx';
import { useElemasonComponentConfig } from '../../../hooks/useElemasonConfig';
import { useToast } from './store';

import type { ToastConfig } from '@tectonic/types';

const Toast = () => {
  const { toast, close } = useToast();
  const { colors } = useThemeContext();

  const toastConfig = useElemasonComponentConfig<ToastConfig>(
    ElemasonComponentType.Toast
  );
  const [style, className] = useStyleConfigV2(toastConfig.container);

  return (
    <UiToast.Provider duration={toast?.duration ?? 3000}>
      <UiToast.Root
        style={{
          ...style,
          backgroundColor:
            colors[toast?.backgroundColor!] ?? style.backgroundColor,
        }}
        open={!!toast}
        onOpenChange={() => close()}
        className={clsx(className, 'flex flex-col')}
      >
        <UiToast.Title className="ToastTitle">
          <Text data={toast?.title} config={toastConfig.title} />
        </UiToast.Title>
        <UiToast.Description>
          <Text data={toast?.description} config={toastConfig.description} />
        </UiToast.Description>
      </UiToast.Root>
      <UiToast.Viewport className="left fixed bottom-0 left-1/2 z-30 flex -translate-x-1/2 flex-col" />
    </UiToast.Provider>
  );
};

export { Toast };
